import { memo, useRef } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import config from 'constants/config'
import Pane from 'components/Common/Pane'
import TrustPilotSection from 'components/Common/TrustReviewSection/TrustPilotSection'
import useExperiment from 'hooks/Optimizely/useExperiment'
import { Experiments } from 'constants/optimizely'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'

const TrustPilotContainer = styled(Pane)`
  box-shadow: ${props => props.theme.shadow.flat.small};
  padding: ${rem(20)} ${rem(24)};
`

const CarouselWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  contain: inline-size;
`

interface Props {
  className?: string
}

function OfferPageTrustPilot({ className }: Props) {
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const startedLoggedInRef = useRef(isLoggedIn)
  const isEligible = !startedLoggedInRef.current
  const isLuxuryEscapes = config.BRAND === 'luxuryescapes'
  const {
    isTurnedOn: isTrustpilotExperimentTurnedOn,
    isAnyVariant: isExperimentEnabled,
  } = useExperiment(
    Experiments.croTrustpilotReviewFeedInOfferPage,
    { canActivate: isLuxuryEscapes && isEligible },
  )
  const isInExperiment = isEligible && isTrustpilotExperimentTurnedOn
  const shouldShow = isEligible && isExperimentEnabled

  if (!isLuxuryEscapes) {
    return null
  }

  if (!isInExperiment) {
    return null
  }

  if (!shouldShow) {
    return null
  }

  return (
    <TrustPilotContainer className={className}>
      <CarouselWrapper>
        <TrustPilotSection />
      </CarouselWrapper>
    </TrustPilotContainer>
  )
}

export default memo(OfferPageTrustPilot)
